import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "@/pages/Home";
import DealDetail from "@/pages/DealDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Privacy from "@/pages/Privacy";
import Cookie from "@/pages/Cookie";
import Termini from "@/pages/Termini";
import ChiSiamo from "@/pages/ChiSiamo";
import Contatti from "@/pages/Contatti";
import CategoryPage from "@/pages/CategoryPage";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import NewsletterUnsubscribe from "@/pages/NewsletterUnsubscribe";
import ComeValutiamo from "@/pages/ComeValutiamo";
import NotFound from "@/pages/NotFound";
import AnchorAd from "@/components/AnchorAd";
import ScrollToTop from "@/components/ScrollToTop";
import BackToTopButton from "@/components/BackToTopButton";
import CookieConsent from "@/components/CookieConsent";
import ExitIntentPopup from "@/components/ExitIntentPopup";
import { JsonLd, schemas } from "@/components/Seo";
// Custom GDPR CookieConsent banner is REQUIRED before AdSense approval:
// Google's certified CMP is loaded only AFTER AdSense is approved.
// Until then (and always, for EU/UK/CH users), our own banner is the only compliant option.
import { Toaster } from "sonner";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        {/* Site-wide structured data */}
        <JsonLd data={schemas.organization()} />
        <JsonLd data={schemas.website()} />
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/categoria/:key" element={<CategoryPage />} />
            <Route path="/guide" element={<Blog />} />
            <Route path="/guide/:slug" element={<BlogPost />} />
            <Route path="/offerta/:id" element={<DealDetail />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookie" element={<Cookie />} />
            <Route path="/termini" element={<Termini />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/newsletter/unsubscribe" element={<NewsletterUnsubscribe />} />
            <Route path="/come-valutiamo" element={<ComeValutiamo />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <AnchorAd />
          <BackToTopButton />
          <CookieConsent />
          <ExitIntentPopup />
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" />
      </div>
    </HelmetProvider>
  );
}

export default App;
